import React, { Component } from 'react';
import CurrencyValue from './currencyValue';
import ChangeValue from './changeValue';

class AltinKur extends Component {
    state = {  
        values: [],
        header: this.props.header,
        style:{height: document.body.clientWidth > 990 ? this.props.height : null}
    }

    componentDidUpdate(prevProps) {
  
        if (this.props.values !== prevProps.values && Array.isArray(this.props.values))
        {
            var values = this.props.values;

            if(this.props.main)
                values = values.filter( (value) => value.Main === true)

            if(this.props.group !== undefined)
                values = values.filter( (value) => value.DataGroup === this.props.group)

            if(this.props.groups !== undefined)
                values = values.filter( (value) => this.props.groups.includes(value.DataGroup))

            if(this.props.webgroup !== undefined)
                values = values.filter( (value) => value.WebGroup === this.props.webgroup)

            // Belirli kodları (ör. ONS) Main/grup filtresinden bağımsız en başa ekle
            if(this.props.prepend !== undefined){
                var forced = this.props.prepend
                    .map( (code) => this.props.values.find( (value) => value.Kod === code) )
                    .filter( (value) => value !== undefined )
                values = forced.concat( values.filter( (value) => this.props.prepend.indexOf(value.Kod) === -1 ) )
            }

            // Belirli kodları (ör. GA) Main/grup filtresinden bağımsız en sona ekle
            if(this.props.append !== undefined){
                var appended = this.props.append
                    .map( (code) => this.props.values.find( (value) => value.Kod === code) )
                    .filter( (value) => value !== undefined )
                values = values.filter( (value) => this.props.append.indexOf(value.Kod) === -1 ).concat(appended)
            }

            this.setState({values})
        }
    }


    showDescription = tag =>{
        // Belirli kodlar için görünen ismi override et (ör. AG -> HAS Gümüş)
        var label = (this.props.labels && this.props.labels[tag['Kod']] !== undefined)
            ? this.props.labels[tag['Kod']]
            : tag['MobilAciklama'];
        return <td>{label} <span>{tag['Aciklama']}</span></td>;
      }

    // Kutu yuksekligini komsu kolonla hizalamak icin bos satir eklemeye yarar.
    emptyRows = () => {
        var count = this.props.emptyRows || 0;
        if (count < 1 || this.state.values.length === 0) return null;
        return Array.from({length: count}, (_, i) =>
            <tr key={'empty' + i} className="empty-row"><td>&nbsp;</td><td></td><td></td><td></td></tr>);
    }

    render() { 
        return <div className={this.props.silverHead ? "card silver-head" : "card gold-head"}>
        <div className="card-body">
            <div className="card-box" style={this.state.style}>
              <div className="table-responsive">
                <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">{this.state.header}</th>
                        <th scope="col">{this.props.hideValueLabels ? '' : 'Alış'}</th>
                        <th scope="col">{this.props.hideValueLabels ? '' : 'Satış'}</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                        {this.state.values.map(tag => <tr key={tag['Kod']} className={this.props.highlightCodes && this.props.highlightCodes.indexOf(tag['Kod']) !== -1 ? 'highlight-row' : undefined}>{this.showDescription(tag)}<CurrencyValue id={'buy' + tag['Kod']} value={tag['Alis']}/><CurrencyValue id={'sell' + tag['Kod']} value={tag['Satis']}/><ChangeValue value={tag['Change']} /></tr>)}
                        {this.emptyRows()}
                    </tbody>
                  </table>
              </div>
            </div>
        </div>
        </div>;
    }

    
}
 
export default AltinKur;